import React from 'react'

import {alpha, Box, Grid, Typography} from "@mui/material"
import {IconSeeker} from "@ui-seeker/core";


export default function pricesColumn(date, providers, weeks, palette) {

    return {
        name: date,
        setBodyRowProps: () => ({ sx:{ p: 0, backgroundColor: 'primary.main', } }),
        setBodyCellProps: () => ({ sx:{ p: 0, verticalAlign: 'top', userSelect: 'none', cursor: 'default' } }),
        render: value => <PriceCell providers={providers} weeks={weeks} palette={palette} value={value} />

    }
}

function PriceCell({value, providers, weeks, palette}) {
    return <Box sx={{ p: 1, borderBottom: 2, borderColor: 'primary.main'}}>
        <Grid container spacing={1} sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
            {providers.map(provider => {
                if(!value?.[provider]) return weeks.map((week, idx) => {
                    return <Grid key={`${provider}-${week}-${idx}`} item xs={12 / weeks.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', flexDirection: 'column' }}>
                        <Typography sx={{ borderRadius: 1, textAlign: 'center', width: '100%', backgroundColor: palette.secondary.lighter }}>N/A</Typography>
                    </Grid>
                })
                return value[provider].map(({price, isCheapest, isMoreExpensive, evolutionComparisonType, evolutionDiffPrice}, idx) => {
                    return <Grid key={`${provider}-${price}-${idx}`} item xs={12 / weeks.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                        <Box sx={{
                            border: 2,
                            borderColor: isCheapest ? palette.error.main : isMoreExpensive ? palette.info.main : price === 'N/A' ? '' : palette.secondary.light,
                            backgroundColor: isCheapest ? alpha(palette.error.main, 0.1) : isMoreExpensive ? alpha(palette.info.main, 0.1) : price === 'N/A' ? '' : alpha(palette.secondary.lighter, 0.5),
                            display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 1, width: '100%'
                        }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography sx={{textAlign: 'center', fontWeight: 'bold'}}>
                                        {price}
                                    </Typography>
                                </Grid>
                                 <Grid item xs={12} sx={{  height: 30 }}>
                                     {!!evolutionComparisonType && evolutionDiffPrice !== null && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, px: 2 }} >
                                        <IconSeeker
                                            icon={evolutionComparisonType === "increase" ? "arrow-up" : evolutionComparisonType === "decrease" ? "arrow-down" : "equals"}
                                            sx={{ color: evolutionComparisonType === "increase" ? "success.dark" : evolutionComparisonType === "decrease" ? "error.main" : "" }}
                                        />
                                        <Typography sx={{textAlign: 'center', fontSize: '.7rem'  }}>
                                            {evolutionDiffPrice}%
                                        </Typography>
                                    </Box>}
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                })
            })}
        </Grid>
    </Box>
}